"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var accountSubCategory_1 = require("./accountSubCategory");
var appearanceSubCategory_1 = require("./appearanceSubCategory");
var configurationSubCategory_1 = require("./configurationSubCategory");
var skypeSubCategory_1 = require("./skypeSubCategory");
var generalCategory = {
    key: 'general',
    titleStringKey: 'optionCategory_General',
    icon: "Settings" /* Settings */,
    subcategories: [
        accountSubCategory_1.default,
        appearanceSubCategory_1.default,
        configurationSubCategory_1.default,
        skypeSubCategory_1.default,
    ],
};
exports.default = generalCategory;
//# sourceMappingURL=category.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-options-general/lib/config/category.js
// module id = 4916
// module chunks = 2